<template>
<div id="app" class="about-page page-template-default page site container hfeed">
  <HeadNav selectedLanguage="en" page="about" :gotodownload="gotodownload" :apk="apk" />

  <div id="page" class="site-content">
    <div id="primary" class="content-area">
      <main id="maincontent" class="site-main legal-wrap">
        <article class="inside-article section-content og-page-prose">
          <header class="entry-header">
            <h1 class="entry-title">
About ogbwhats.com
</h1>
          </header>

          <div class="og-page-prose__inner" itemprop="text">
          <p>
            ogbwhats.com exists for one straightforward purpose: help Android users understand what people usually call <strong>OG WhatsApp</strong>, how an <strong>OG WhatsApp APK</strong> differs from the stock app,
            and what practical risks come with sideloading software that WhatsApp LLC does not publish.
          </p>

          <h2>What we do</h2>
          <p>
            We publish guides, comparisons, and cautious download pointers. We summarize features in everyday language because most readers simply want fewer surprises—not marketing hype.
            When we mention <strong>download OG WhatsApp latest version</strong> flows, we still expect you to double-check filenames, sizes, and checksum guidance from the distributor you trust.
          </p>

          <h2>What we are not</h2>
          <p>
            We are <strong>not</strong> WhatsApp, Meta, or any official partner. We do not speak for them, and we do not claim endorsement. Trademark names belong to their owners; our site is editorial by nature.
          </p>

          <h2>How to reach us</h2>
          <p>
            Use the contact channel listed on this site if you spot outdated instructions or broken links. We fix mistakes when we can, but we cannot troubleshoot individual phones line-by-line.
          </p>

          <p>
            For policies that affect browsing data here—not inside WhatsApp itself—read our <router-link to="/privacy/">
Privacy Policy
</router-link> and <router-link to="/disclaimer/">
Disclaimer
</router-link>.
          </p>
          </div>
        </article>
      </main>
    </div>
  </div>
</div>
</template>
<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'About',
  components: { HeadNav },
  data() {
    return {
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code == 200 && type == 1) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style scoped>
/* 与首页正文一致：铺满容器宽度，覆盖全局 .section-content 的 75% */
.og-page-prose.inside-article.section-content {
  width: 100% !important;
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  padding: 24px max(16px, env(safe-area-inset-right)) 48px max(16px, env(safe-area-inset-left));
  box-sizing: border-box;
}

.legal-wrap {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.og-page-prose__inner {
  max-width: 100%;
}

.og-page-prose__inner p {
  font-size: 1.02rem;
  line-height: 1.7;
  color: #2a332f;
}

.og-page-prose__inner h2 {
  margin-top: 1.5rem;
  color: #333333;
}
</style>